var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProblem3 = function SvgProblem3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__a)",
    fillRule: "evenodd",
    d: "M10.931 3.67a7.264 7.264 0 0 0-7.263 7.266 7.264 7.264 0 0 0 7.263 7.266 7.264 7.264 0 0 0 7.263-7.266A7.264 7.264 0 0 0 10.93 3.67M0 10.936C0 4.896 4.894 0 10.931 0s10.931 4.896 10.931 10.936-4.894 10.936-10.931 10.936S0 16.975 0 10.936",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__b)",
    fillRule: "evenodd",
    d: "M73.069 3.67a7.264 7.264 0 0 0-7.263 7.266 7.264 7.264 0 0 0 7.263 7.266 7.264 7.264 0 0 0 7.263-7.266 7.264 7.264 0 0 0-7.263-7.266m-10.931 7.266C62.138 4.896 67.032 0 73.069 0S84 4.896 84 10.936s-4.894 10.936-10.931 10.936-10.931-4.897-10.931-10.936",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__c)",
    fillRule: "evenodd",
    d: "M63.935 16.073h-43.87V5.798h43.87z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__d)",
    fillRule: "evenodd",
    d: "M10.931 65.798a7.264 7.264 0 0 0-7.263 7.266 7.264 7.264 0 0 0 7.263 7.266 7.264 7.264 0 0 0 7.263-7.266 7.264 7.264 0 0 0-7.263-7.266M0 73.064c0-6.04 4.894-10.935 10.931-10.935s10.931 4.896 10.931 10.935S16.968 84 10.931 84 0 79.104 0 73.064",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__e)",
    fillRule: "evenodd",
    d: "M73.069 65.798a7.264 7.264 0 0 0-7.263 7.266 7.264 7.264 0 0 0 7.263 7.266 7.264 7.264 0 0 0 7.263-7.266 7.264 7.264 0 0 0-7.263-7.266m-10.931 7.266c0-6.04 4.894-10.935 10.931-10.935S84 67.025 84 73.064 79.106 84 73.069 84s-10.931-4.896-10.931-10.936",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__f)",
    fillRule: "evenodd",
    d: "M63.935 78.202h-43.87V67.927h43.87z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__g)",
    fillRule: "evenodd",
    d: "M16.067 20.037v43.926H5.796V20.037z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_3_svg__h)",
    fillRule: "evenodd",
    d: "M78.204 20.037v43.926h-10.27V20.037z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__a",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__b",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__c",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__d",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__e",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__f",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__g",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_3_svg__h",
    x1: 42,
    x2: 42,
    y1: 0,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgProblem3;